<script lang="ts">
  import { getTextStyle, styleToString } from "@shared/common/node/style";
  import type { ITextNode, PartialNode } from "@shared/common/node/type";
  import type { ICampaignSetting } from "@shared/common/types/campaign";
  import { stringTemplateHelper } from "@shared/common/utils/string-template-helper";
  import { getContext, onMount } from "svelte";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const campaignSetting = getContext<ICampaignSetting>("campaignSetting");

  const { dataMap, reactionEventListener, t } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<ITextNode>;

  // bind:offsetWidth 로 하지 않는 이유는 특수한 상황에서만 사용하기 때문
  let textEle: HTMLElement | null = null;

  onMount(() => {
    if (node.fontSize?.unit !== "%/W") {
      return;
    }

    const setDynamicWidth = () => {
      if (node.fontSize?.unit === "%/W") {
        textEle?.style.setProperty(
          "font-size",
          `${(textEle.offsetWidth * node.fontSize.value) / 100}px`
        );
      }
    };

    const observer = new ResizeObserver(setDynamicWidth);

    if (textEle) {
      observer.observe(textEle);
    }

    return () => {
      observer.disconnect();
    };
  });
</script>

<div
  bind:this={textEle}
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
  style={styleToString(getTextStyle(node, campaignSetting.language))}
>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html stringTemplateHelper({ mode: "VIEW", t: $t }).render(
    node.content || "",
    $dataMap
  )}
</div>
